import React, { useEffect, useState, useRef, useCallback} from "react";
import Select from "react-select";
import './dashboard.css';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import { AgGridReact } from 'ag-grid-react';
import LoaderComponent from "../../../../libraries/loader/loader";

import {baseUrl} from "../../../../services/common/credentials";
import { port1 } from '../../../../services/auth-service/authService';

import { Input } from 'semantic-ui-react';



var local_host = baseUrl + port1;


function ConsolidationReport() {
    const [inputMonth, setInputMonth] = useState(undefined);
    const [hideResultGrid, setHideResultGrid] = useState(true);
    const [loaderOpen, setLoaderOpen] = useState(false);
    const [userCredentials] = useState(JSON.parse(sessionStorage.getItem("userCredentials")));
    const [rowData, setRowData] = useState([]);
    const [paginationSize] = useState(15);
    const [inputMonth1, setInputMonth1] = useState(undefined);
 

    var utr_columns = [
       
        { field: 'processed_date', headerName: 'processed_date', sortable: true, filter: true, resizable: true, editable: true },
        { field: 'num_of_client_ids', headerName: 'num_of_client_ids', sortable: true, filter: true, resizable: true },
        { field: 'user_ids_of_mail_ids', headerName: 'user_ids_of_mail_ids', sortable: true, filter: true, resizable: true },
        { field: 'total_mail_ids', headerName: 'total_mail_ids', sortable: true, filter: true, resizable: true },
        { field: 'no_of_mails_sent', headerName: 'no_of_mails_sent', sortable: true, filter: true, resizable: true },
        
    ];


    useEffect(() => {
        setLoaderOpen(false);
    }, []);

    const makeAPICall = async (url) => {
        try {
            setLoaderOpen(true);
            
            const response = await fetch(url);
            const data = await response.json();
            setRowData(data);
            console.log('data', data);
            setHideResultGrid(false);
            setLoaderOpen(false);
        }
        catch (e) {
            console.log(e);
            setLoaderOpen(false);
            setHideResultGrid(true);
        }
    }
  
    

    const customStyles = {
        control: base => ({
            ...base,
            height: 35,
            minHeight: 35,
            marginTop: 0,
            paddingTop: -5,
            fontSize: 14,
        })
    };


    function searchClick(event) {
        if (inputMonth === undefined) {
            alert("Please Select input month!!!");
        }

        else{
            let url = '';
            let month = String(inputMonth);
            let month1 = String(inputMonth1);
            let tenants_id=  userCredentials["tenants_id"];
            let entities_id = userCredentials["entities_id"];
            if (month) {
                url = local_host+`/api/v2/alcs/fetch_kpi_info/?month=${month}&&month1=${month1}&&tenants_id=${tenants_id}&&entities_id=${entities_id}`;
            }
            makeAPICall(url);
        }
    }
    

    function onChangeMonth(e){
        setInputMonth(e.target.value);
        console.log(e.target.value);
    }

    function onChangeMonth1(e){
        setInputMonth1(e.target.value);
        console.log(e.target.value);
    }


    return (
        <>
            <div className="report-cardBox">
                <div className="" style={{ marginLeft: "-10px" }}>
                    <div>
                        <label id="underline_select" htmlFor="underline_select " style={{ fontSize: '15px', marginLeft:'15px' }}>From Date</label><br />
                        <Input type="date" className="cardName filetype" style={{ paddingLeft: "10px", marginTop:'5px' }} onChange={(e) => onChangeMonth(e)} />
                    </div>
                </div>
                <div>
                    
                    <label id="underline_select" htmlFor="underline_select " style={{ fontSize: '15px', marginLeft:'15px' }}>To Date</label><br />
                    <Input type="date" className="cardName filetype" style={{ paddingLeft: "10px", marginTop:'5px' }} onChange={(e) => onChangeMonth1(e)} />
                    
                </div>
                
                {inputMonth ?
                    <button className="btn" style={{ height: "35px", width: "92px", marginTop: "28px", backgroundColor: "#000055", color: "#ffffff" }} onClick={(e) => { searchClick(e) }}>Search</button>
                    : <button className="btn" disabled={true} style={{ height: "35px", width: "92px", marginTop: "28px", backgroundColor: "#000055", color: "#ffffff" }}>Search</button>
                }
            </div>
            
            <div className="report" hidden={hideResultGrid}>
                
                <div className="ag-theme-balham report-layer" style={{width:'100%', heidght:'100%'}}>
                    <AgGridReact
                        columnDefs={utr_columns}
                        rowData={rowData}
                        paginationPageSize={25}
                        pagination={true}
                        animateRows={true}
                        rowSelection={'multiple'}
                        groupSelectsChildren={true}
                        suppressAggAtRootLevel={true}
                        suppressRowClickSelection={true}
   
                    >
                    </AgGridReact>
                </div>
            </div>
          
            <LoaderComponent loaderOpen={loaderOpen} />

        </>
    )
}

export default ConsolidationReport;










